export default "__VITE_ASSET__ZIwn32gy__"